var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 181,
    viewBox: "0 0 169 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168.08,
    height: 180.78,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4584,
    y: 11.2054,
    width: 147.911,
    height: 159.116,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4108,
    y: 23.9048,
    width: 125.5,
    height: 133.717,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2639 42.2551L18.7931 35.9928L32.0137 20.7644L38.2219 23.8214L22.2639 42.2551Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5651 63.3204L20.1321 54.7048L50.0462 20.1991L57.7055 21.5803L21.5651 63.3204Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.259 31.4011L129.714 27.1279L157.768 41.3137L157.192 48.5213L123.259 31.4011Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.801 42.6064L120.029 38.7236L154.421 56.1074L154.395 63.593L112.801 42.6064Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.595 56.0528L109.687 52.6056L151.15 73.5581L151.739 81.3539L101.595 56.0528Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2402 83.8983L88.1808 81.6758L154.04 113.182L156.879 121.959L77.2402 83.8983Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.718 97.4901L75.182 94.622L153.268 131.973L157.169 141.261L65.718 97.4901Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8857 70.2722L98.8014 67.5599L156.265 95.0536L158.374 103.481L88.8857 70.2722Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2939 86.0079L20.7142 75.2524L65.8084 23.217L74.7873 23.0743L20.2939 86.0079Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2518 112.025L22.0776 98.4917L86.8771 23.7011L97.569 21.5803L19.2518 112.025Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0472 138.814L22.4114 122.349L108.004 23.5473L120.503 19.3392L17.0472 138.814Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7937 166.17L22.7457 146.716L129.537 23.4343L143.879 17.0982L14.7937 166.17Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2163 170.333L35.0014 159.157L83.084 103.67L92.3227 103.228L34.2163 170.333Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8682 170.406L58.8047 160.209L99.9372 112.748L108.572 113.004L58.8682 170.406Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.255 167.219L86.1707 158.201L118.941 120.397L126.848 121.492L87.255 167.219Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.895 166.867L112.827 158.985L137.536 130.489L144.743 132.393L114.895 166.867Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72173331b186fc73eaa919e336e48136.svg";
export { ForwardRef as ReactComponent };